import React, {Component} from 'react'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import moment from 'moment'
import DateRangePicker from 'react-bootstrap-daterangepicker'
import {updateCompareDates, compareStatus, getPayload } from 'actions'


var BS = require('react-bootstrap')


class DatePickerCompare extends Component {

    handleEvent = (event, picker) => {
        var dates = {
            startDate:picker.startDate,
            endDate:picker.endDate
        }
		localStorage.setItem('compareDates', JSON.stringify(dates))
		console.log(picker)
        this.props.updateCompareDates(picker)
        this.props.getPayload()
    }

    handleHide = (event, picker) => {
    }

    cancel = (event, picker) => {
        this.props.compareStatus(false)
    }

    render() {
        var ranges = {
           'Todayyy': [moment(), moment()],
           'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
           'Last 7 Days': [moment().subtract(6, 'days'), moment()],
           'Last 30 Days': [moment().subtract(29, 'days'), moment()],
           'This Month': [moment().startOf('month'), moment().endOf('month')],
           'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
           'Past Year': [moment().subtract(1, 'years'), moment()],
           //'All Time': [moment().subtract(100, 'years'), moment()]
        }
        var label = this.props.dates.startText + ' - ' + this.props.dates.endText
        if (this.props.dates.startText === this.props.dates.endText) {
            label = this.props.dates.startText
        }
        else if(this.props.dates.start.valueOf() < 0) {
            label = 'All Time'
        }
		if (!this.props.stateCompareStatus) {
			return ""
		} else {
			return (
				<div className="title__datePickerCompare">
					<DateRangePicker
						startDate={this.props.dates.start}
						endDate={this.props.dates.end}
						ranges={ranges}
						onApply={this.handleEvent}
						opens={"left"}>
						<BS.Button className="selected-date-range-btn" style={{}}>
							<div className="pull-right">
								<span>{label}</span>
							</div>
						</BS.Button>
					</DateRangePicker>
				</div>
			)
		}
    }
}

function mapStateToProps(state) {
    return {
        dates: state.compareDates,
		compareOverlay: state.compareOverlay,
		stateCompareStatus: state.compareStatus
    }
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        updateCompareDates: updateCompareDates,
        compareStatus: compareStatus,
        getPayload
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(DatePickerCompare)
